// extracted by mini-css-extract-plugin
module.exports = {"root":"_a96732","pagination":"_9021bd","link":"_08c053","typography":"_db0fc7"};